module.exports = __webpack_public_path__ + "static/media/9DESA21.dc8520f8.jpg";